/* PWW v103: collection pages default to lowest price; search pages preserve Shopify relevance. */
(function () {
  var path = window.location.pathname;
  var isCollectionPage = /^\/collections(?:\/|$)/.test(path);
  if (!isCollectionPage) return;

  var params = new URLSearchParams(window.location.search);
  if (params.has('sort_by')) return;

  params.set('sort_by', 'price-ascending');
  window.location.replace(path + '?' + params.toString() + window.location.hash);
})();
